import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<number> = (stickyTop) => ({
  top: stickyTop,
});

export const container: SxStyle = {
  position: 'absolute',
  top: '-11px',
  left: '320px',
  display: 'flex',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
  background: (p) => p.palette.common.white,
  padding: (p) => p.spacing(0, 1.5),
  borderRadius: (p) => p.spacing(3),
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[500],
  color: (p) => p.palette.primary[500],
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  cursor: 'pointer',
  height: (p) => p.spacing(3),
};

export const icon: SxStyle = {
  background: (p) => p.palette.primary[100],
  color: (p) => p.palette.primary[500],
  borderRadius: (p) => p.spacing(0.5),
};

export const content: SxStyle = {
  display: 'flex',
  gap: (p) => p.spacing(1.5),
};

export const button: SxStyle = {
  background: (p) => p.palette.primary[50],
  minWidth: 0,
  height: (p) => p.spacing(3),
  width: (p) => p.spacing(3.5),
  padding: 0,
};

export const title: SxStyle = {};

export const message: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: (p) => p.palette.primary[500],
  background: (p) => p.palette.primary[50],
  borderRadius: (p) => p.spacing(1.5),
  padding: (p) => p.spacing(0, 3),
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};
